// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"207":"dd365777","485":"a37b57dc","720":"9015a028","839":"7655871f","930":"9709673b"}[chunkId] + ".chunk.css";
};